export default "__VITE_ASSET__D8zczu6L__"